module.exports = __webpack_public_path__ + "static/3-5d34126afe667ff0598790edbb7e4c75.png";